import {pathHelpContentFile} from '../../../utils/path';
import {CONTENT_TYPE_TEXT, CONTENT_TYPE_IMAGE, CONTENT_CATEGORY_DOCUMENT} from '../../constants';

export default {
  id: 'SPEC_DOC',
  title: 'Come trovare un modello di attestazione?',
  description: '',
  categories: [CONTENT_CATEGORY_DOCUMENT],
  contents: [{
    type: CONTENT_TYPE_TEXT,
    value: 'Se hai qualche dubbio su un documento da depositare, devi solo:'
  },
  {
    type: CONTENT_TYPE_TEXT,
    adornment: '1.',
    value: 'Clicca sul documento desiderato e clicca sul pulsante «Clicca per vedere un modello del documento atteso»'
  },
  {
    type: CONTENT_TYPE_IMAGE,
    value: `${pathHelpContentFile}it/IT_SPEC_DOC/IT_SPEC_DOC.png`
  },
  {
    type: CONTENT_TYPE_TEXT,
    value: 'Se non riesci a trovare il modello di un documento, non esitare a consultare i modelli nella nostra pagina «Aiuto e Contatto».'
  }]
};
